import React, { useEffect, useRef } from 'react';

export default function PointCobroWaitingModal({ isOpen, point, monto }) {
  const dialog = useRef(null);
  const canCancel = Boolean(point.cobro?.activo && !point.loading && !point.cobro.cancelacionSolicitada);

  useEffect(() => {
    if (!isOpen) return;
    const previousFocus = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) (dialog.current?.querySelector('button:not(:disabled)') || dialog.current)?.focus();
  }, [isOpen, canCancel]);

  if (!isOpen) return null;
  const cancelling = point.cobro?.cancelacionSolicitada || point.cobro?.estado === 'cancelando';
  const error = point.error || point.cobro?.incidencia || point.cobro?.cancelacionError;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div ref={dialog} role="dialog" aria-modal="true" aria-labelledby="point-waiting-title"
        aria-describedby="point-waiting-status" tabIndex={-1}
        className="w-full max-w-md max-h-full overflow-auto rounded-2xl bg-white p-6 sm:p-8 shadow-2xl outline-none"
        onKeyDown={event => {
          if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); }
          if (event.key === 'Tab') {
            event.preventDefault();
            (dialog.current?.querySelector('button:not(:disabled)') || dialog.current)?.focus();
          }
        }}>
        <div className="flex flex-col items-center text-center">
          <div aria-hidden="true" className="relative mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50 text-primary">
            <span className="absolute inset-0 rounded-full border-4 border-blue-100 border-t-primary motion-safe:animate-spin" />
            <span className="material-symbols-outlined text-4xl">point_of_sale</span>
          </div>
          <h2 id="point-waiting-title" className="text-2xl font-bold text-[#111618]">Operando el posnet</h2>
          <p id="point-waiting-status" role="status" className="mt-2 text-[#617c89]">
            {cancelling ? 'Cancelando' : 'Esperando pago'}
          </p>
          <p className="mt-5 text-3xl font-bold tabular-nums text-[#111618]">
            ${Number(point.cobro?.monto ?? monto).toFixed(2)}
          </p>
          {error && <p role="alert" className="mt-4 break-words text-sm text-red-700">{error}</p>}
          {point.cobro?.activo && <button type="button" onClick={point.cancelar} disabled={!canCancel}
            className="mt-6 h-12 w-full rounded-lg border border-gray-300 bg-white px-6 font-medium text-[#111618] hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>}
        </div>
      </div>
    </div>
  );
}
